<template>
  <div
    class="modal modal-bottom fade"
    id="confirm-sheet-modal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="confirm-sheet-modal"
    style="z-index: 10000"
  >
    <div class="modal-dialog" role="document">
      <div class="modal-content mlx-notice">
        <div class="modal-header" style="border: 0; padding: 0.1rem 1rem">
          <button
            type="button"
            class="btn-close text-dark"
            data-bs-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div
          class="modal-body mlx-notice-body text-center"
          :style="{ '--mlx-accent': themeColorTheme2 }"
        >
          <span v-if="icon" class="material-icons-round mlx-notice-icon">{{
            icon
          }}</span>
          <div class="mlx-notice-message">
            <strong v-html="message"></strong>
          </div>
          <!-- Optional interactive block between the message and the buttons —
               the message itself is v-html and so cannot carry controls. -->
          <slot></slot>
          <div class="mlx-notice-actions">
            <button
              type="button"
              class="mlx-notice-btn mlx-notice-btn--ghost"
              data-bs-dismiss="modal"
            >
              {{ cancelText }}
            </button>
            <button
              type="button"
              class="mlx-notice-btn mlx-notice-btn--primary"
              :style="`background: ${themeColorTheme2} !important;`"
              data-bs-dismiss="modal"
              @click="processYes"
            >
              {{ confirmText }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <button
      class="btn-confirm-sheet-modal"
      style="display: none"
      data-bs-toggle="modal"
      data-bs-target="#confirm-sheet-modal"
    >
      Confirm
    </button>
  </div>
</template>

<script>
// Confirm dialog wearing the same mlx- bottom-sheet skin as ModalSuccess.vue,
// so a screen that confirms and then reports uses one visual language. Kept
// separate from the shared ModalConfirm.vue, which is a centred card three
// other screens depend on.
export default {
  name: "ModalConfirmSheet",
  props: {
    // Rendered with v-html so callers can pass a richer layout, same single
    // slot contract ModalSuccess exposes.
    message: {
      type: String,
      default: "",
    },
    // Material icon ligature shown above the message; omit for none.
    icon: {
      type: String,
      default: "",
    },
    confirmText: {
      type: String,
      default: "Confirm",
    },
    cancelText: {
      type: String,
      default: "Cancel",
    },
    processYes: {
      type: Function,
      default: () => {},
    },
  },
  computed: {
    themeColorTheme2() {
      return this.$store.state.mainThemeColorTheme2
        ? this.$store.state.mainThemeColorTheme2
        : this.$store.state.color;
    },
  },
};
</script>
<style scoped>
/* Same notice sheet ModalSuccess.vue uses, with a two-button footer. */
.mlx-notice {
  border-radius: 24px 24px 0 0;
  box-shadow: 0 -8px 24px rgba(0, 0, 0, 0.08);
}
.mlx-notice-body {
  padding: 8px 24px 32px !important;
}
.mlx-notice-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 64px;
  height: 64px;
  margin: 0 auto;
  border-radius: 9999px;
  font-size: 30px;
  color: var(--mlx-accent);
  background: color-mix(in srgb, var(--mlx-accent) 12%, #ffffff);
}
.mlx-notice-message {
  padding: 20px 0 24px;
  font-size: 16px;
  line-height: 1.6;
  color: #201a1a;
}
.mlx-notice-actions {
  display: flex;
  gap: 10px;
}
.mlx-notice-btn {
  flex: 1;
  height: 48px;
  border: none;
  font-weight: 700;
  font-size: 15px;
  letter-spacing: 0.02em;
  border-radius: 9999px;
  cursor: pointer;
  transition: transform 0.1s ease, opacity 0.2s ease;
}
.mlx-notice-btn:active {
  transform: scale(0.98);
}
.mlx-notice-btn--ghost {
  background: transparent;
  border: 1px solid rgba(32, 26, 26, 0.25);
  color: #201a1a;
}
.mlx-notice-btn--primary {
  color: #ffffff;
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.14);
}

/* Css model */
.modal.modal-left .modal-dialog,
.modal.modal-right .modal-dialog,
.modal.modal-top .modal-dialog,
.modal.modal-bottom .modal-dialog {
  -webkit-transform: translate3d(0%, 0, 0);
  -ms-transform: translate3d(0%, 0, 0);
  -o-transform: translate3d(0%, 0, 0);
  transform: translate3d(0%, 0, 0);
}

/* Left & Right */

.modal.modal-left .modal-dialog,
.modal.modal-right .modal-dialog {
  position: fixed;
  margin: auto;
  width: 500px;
  max-width: 100%;
  height: 100%;
}

.modal.modal-left .modal-content,
.modal.modal-right .modal-content {
  height: 100%;
  overflow-y: auto;
}

.modal.modal-left .modal-body,
.modal.modal-right .modal-body {
  padding: 15px 15px 80px;
}

.modal.modal-left.fade .modal-dialog {
  left: -500px;
  -webkit-transition: opacity 0.3s linear, left 0.3s ease-out;
  -moz-transition: opacity 0.3s linear, left 0.3s ease-out;
  -o-transition: opacity 0.3s linear, left 0.3s ease-out;
  transition: opacity 0.3s linear, left 0.3s ease-out;
}

.modal.modal-left.fade.show .modal-dialog {
  left: 0;
}

.modal.modal-right.fade .modal-dialog {
  right: -500px;
  -webkit-transition: opacity 0.3s linear, right 0.3s ease-out;
  -moz-transition: opacity 0.3s linear, right 0.3s ease-out;
  -o-transition: opacity 0.3s linear, right 0.3s ease-out;
  transition: opacity 0.3s linear, right 0.3s ease-out;
}

.modal.modal-right.fade.show .modal-dialog {
  right: 0;
}

.modal.modal-left .modal-content,
.modal.modal-right .modal-content,
.modal.modal-top .modal-content,
.modal.modal-bottom .modal-content,
.modal.modal-full .modal-content {
  border-radius: 0;
  border: none;
}

.modal.modal-left .modal-dialog.modal-sm,
.modal.modal-right .modal-dialog.modal-sm {
  width: 300px;
}

.modal.modal-left .modal-dialog.modal-lg,
.modal.modal-right .modal-dialog.modal-lg {
  width: 800px;
}

.modal.modal-left .modal-dialog.modal-xl,
.modal.modal-right .modal-dialog.modal-xl {
  width: 1140px;
}

/* Top and Bottom */

.modal.modal-top .modal-dialog,
.modal.modal-bottom .modal-dialog {
  position: fixed;
  margin: auto;
  width: 100%;
  max-width: 100%;
  height: auto;
}

.modal.modal-top .modal-content,
.modal.modal-bottom .modal-content {
  height: auto;
  overflow-y: auto;
}

.modal.modal-top .modal-body,
.modal.modal-bottom .modal-body {
  padding: 15px 15px;
}

/* Top */

.modal.modal-top.fade .modal-dialog {
  top: -100%;
  -webkit-transition: opacity 0.3s linear, top 0.3s ease-out;
  -moz-transition: opacity 0.3s linear, top 0.3s ease-out;
  -o-transition: opacity 0.3s linear, top 0.3s ease-out;
  transition: opacity 0.3s linear, top 0.3s ease-out;
}

.modal.modal-top.fade.show .modal-dialog {
  top: 0;
}

/* Bottom */

.modal.modal-bottom.fade .modal-dialog {
  bottom: -100%;
  -webkit-transition: opacity 0.3s linear, bottom 0.3s ease-out;
  -moz-transition: opacity 0.3s linear, bottom 0.3s ease-out;
  -o-transition: opacity 0.3s linear, bottom 0.3s ease-out;
  transition: opacity 0.3s linear, bottom 0.3s ease-out;
}

.modal.modal-bottom.fade.show .modal-dialog {
  bottom: 0;
}

.modal.modal-bottom.fade .modal-dialog {
  bottom: -100%;
}

/* Full Screen */

.modal.modal-full .modal-dialog {
  position: fixed;
  margin: auto;
  width: 100%;
  max-width: 100%;
  height: 100%;
}

.modal.modal-full .modal-content {
  height: 100%;
  overflow-y: auto;
}

.modal.modal-full .close-modal {
  position: fixed;
  top: 0;
  right: 3rem;
}

/* Footer */

.modal-footer-fixed {
  position: fixed;
  bottom: 0;
  width: 100%;
  background: #fff;
  border-radius: 0;
}

/* XS */

.modal.modal-left.xs .modal-body,
.modal.modal-right.xs .modal-body {
  padding: 15px;
}

.btn-close {
  font-size: 25px;
  color: #222 !important;
}

.btn-close span {
  color: #222;
}
</style>
